var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconChevronDown = function SvgIconChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 15.075a.7.7 0 0 1-.275-.05.8.8 0 0 1-.25-.175L6.525 9.9q-.2-.2-.188-.538a.77.77 0 0 1 .213-.537q.25-.25.537-.213a.94.94 0 0 1 .513.238l4.4 4.4 4.4-4.4a.82.82 0 0 1 .537-.225.59.59 0 0 1 .538.225.55.55 0 0 1 .212.525.97.97 0 0 1-.237.55l-4.925 4.925a.8.8 0 0 1-.25.175.7.7 0 0 1-.275.05"
  })));
};
export default SvgIconChevronDown;